<template>
    <!-- Auth redesign — 6-значный код подтверждения (макет Claude Design).
         Поддержка: ввод/стирание с авто-переходом, стрелки, вставка. -->
    <div class="otp" :class="{ invalid: this.invalid }" @paste="this.onPaste">
        <input v-for="(c, i) in this.cells" :key="i" :ref="(el) => this.setRef(el, i)"
            class="otp-cell" :class="{ filled: c }" type="text" inputmode="numeric" maxlength="1" autocomplete="one-time-code"
            :value="c" :aria-label="`${$t('views.Login.31')} ${i + 1}`"
            @input="this.onInput(i, $event)" @keydown="this.onKey(i, $event)" />
    </div>
</template>

<script>
export default {
    props: {
        value: { type: String, default: '' },
        len: { type: Number, default: 6 },
        invalid: { type: Boolean, default: false },
    },
    emits: ['update:value', 'complete'],
    created() {
        // refs держим вне data — не реактивно (хранение DOM-узлов в data бьёт по перфу)
        this.cellRefs = [];
    },
    computed: {
        cells() {
            const v = this.value || '';
            return Array.from({ length: this.len }, (_, i) => v[i] || '');
        },
    },
    methods: {
        setRef(el, i) { if (el) this.cellRefs[i] = el; },
        focusAt(i) { this.$nextTick(() => { const el = this.cellRefs[i]; if (el) el.focus(); }); },
        emitValue(v) {
            const nv = v.slice(0, this.len);
            this.$emit('update:value', nv);
            if (nv.length === this.len) this.$emit('complete', nv);
        },
        setAt(i, ch) {
            const arr = this.cells.slice();
            arr[i] = ch;
            this.emitValue(arr.join(''));
        },
        onInput(i, e) {
            const d = (e.target.value || '').replace(/\D/g, '');
            if (!d) { this.setAt(i, ''); return; }
            this.setAt(i, d[d.length - 1]);
            if (i < this.len - 1) this.focusAt(i + 1);
        },
        onKey(i, e) {
            if (e.key === 'Backspace' && !this.cells[i] && i > 0) this.focusAt(i - 1);
            else if (e.key === 'ArrowLeft' && i > 0) this.focusAt(i - 1);
            else if (e.key === 'ArrowRight' && i < this.len - 1) this.focusAt(i + 1);
        },
        onPaste(e) {
            e.preventDefault();
            const d = ((e.clipboardData && e.clipboardData.getData('text')) || '').replace(/\D/g, '').slice(0, this.len);
            if (d) { this.emitValue(d); this.focusAt(Math.min(d.length, this.len - 1)); }
        },
    },
};
</script>

<style lang="scss" scoped>
.otp { display: flex; gap: 10px; }
.otp-cell {
    flex: 1 1 0; min-width: 0; height: 56px; text-align: center;
    font-family: 'HelveticaNeue roman', 'Roboto', sans-serif;
    font-size: 22px; font-weight: 600; color: var(--ink);
    background: var(--field); border: 1.5px solid var(--line-strong);
    border-radius: var(--radius-field); outline: none;
    transition: border-color .16s ease, box-shadow .16s ease;
}
.otp-cell:hover { border-color: #bcc0cc; }
.otp-cell:focus { border-color: var(--accent); box-shadow: 0 0 0 4px color-mix(in srgb, var(--accent) 16%, transparent); }
.otp-cell.filled { border-color: color-mix(in srgb, var(--accent) 55%, var(--line-strong)); }
.otp.invalid .otp-cell { border-color: var(--danger); }
@media (max-width: 540px) { .otp { gap: 7px; } .otp-cell { height: 50px; font-size: 19px; } }
</style>
